export const checkLoginStatus = async (apiEndpoint) => {
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) {
      console.error("Failed to check login status:", response.statusText);
      return { loggedIn: false, error: "Failed to check login status" };
    }

    const data = await response.json();

    if (data.loggedIn) {
      return { loggedIn: true, look: data.user.look, coins: data.user.coins };
    } else {
      console.log("User is not logged in");
      return { loggedIn: false };
    }
  } catch (error) {
    console.error("Error checking login status:", error);
    return { loggedIn: false, error: error.message };
  }
};
